// extracted by mini-css-extract-plugin
module.exports = {"buttonPrimary":"buttons_buttonPrimary__vONsH","removeBook":"buttons_removeBook__1ggtB"};